"use strict";
/**
 * PDF Upload Domain — DynamoDB Database Record Types
 *
 * Records for PDF upload sessions, global PDF blob metadata,
 * per-pattern PDF attachments, hash-based fan-out links,
 * oversized upload tracking, and platform moderation tickets.
 */
Object.defineProperty(exports, "__esModule", { value: true });
